import { baseApi } from "./base-api";
import {getPagedResponse, PagedResponse} from "../../../utils/helpers";
import { buildEntityTags } from "../../../utils/api-utils";
import { Dashboard } from "../../data/entities/dashbord";


export const dashboardApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getDashboard: build.query<Dashboard, {startDate: string, endDate: string}>({
      query: (params) => ({
        url: `dashboard/getDashboard`,
        params
      }),
    }),
  }),overrideExisting: true,
});
export const {
  useLazyGetDashboardQuery,
} = dashboardApi;
